import { render, staticRenderFns } from "./GardenersExport.vue?vue&type=template&id=753f4350&scoped=true"
import script from "./GardenersExport.vue?vue&type=script&lang=js"
export * from "./GardenersExport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "753f4350",
  null
  
)

export default component.exports